import React from 'react'

const HomeText = ({h3, h1, p, li1, li2, li3, li4}) => {
    return (
        <div className="home_project_text">
            <h3>{h3}</h3>
            <h1>{h1}</h1>
            <p>{p}</p>
            <ul>
                <li>{li1}</li>
                <li>{li2}</li>
                <li>{li3}</li>
                <li>{li4}</li>
            </ul>
        </div>
    )
}

export default HomeText
